import { useState } from 'react';
import { ClientClient, ClientDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useClientApi = () => {
    const apiClient = new ClientClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ClientDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createClient(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Client');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ClientDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateClient(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Client');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getClientById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Client');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchClients(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Clients');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteClient(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Client');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};